module.exports = __webpack_public_path__ + "media/images/top-search-bg-2@2x-edbad4e81857056ca719ac75a0f4bc31.png";